export default {
  'users-groups.title': 'Gestionar Grupos de Usuarios',
  'users-groups.userExists': 'Usuario Existe',
  'users-groups.form.selectUser': 'Selecciona un Usuario',
};
